import { Tooltip } from 'antd';
import React from 'react';
import { sortParams } from '../../../../../constants/common';
import { ReactComponent as HouseCertificateIcon } from '../../../../../../../resource/HouseCertificateIcon.svg';

const getColorStyle = (isActive) => ({
  color: isActive ? '#0995ed' : '#afafaf',
});

const SortStagesLife = ({ onSort, sortConfig }) => {
  return (
    <Tooltip>
      <HouseCertificateIcon
        onClick={(e) => {
          e.stopPropagation();
          onSort({
            key: 'num/create',
            param: sortParams.SORT_STAGE_LIFE_CYCLE,
          });
        }}
        style={getColorStyle(
          sortConfig?.param === sortParams.SORT_STAGE_LIFE_CYCLE
        )}
      />
    </Tooltip>
  );
};

export default SortStagesLife;
